export default function emptyStringToNull(
  value?: string | null,
): string | null {
  if (typeof value !== 'string') {
    return value ?? null;
  }

  const trimmed = value.trim();

  return trimmed === '' ? null : trimmed;
}
